import { commonjsGlobal as h } from "./index168.js";
import { __exports as _ } from "./index176.js";
import x from "react";
import "./index171.js";
import "./index187.js";
import { __exports as S } from "./index175.js";
import { __exports as T } from "./index189.js";
var k = h && h.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(_, "__esModule", { value: !0 });
_.default = y;
var p = x, C = k(S), s = T, M = {
  cloneElement: p.cloneElement,
  createElement: p.createElement,
  isValidElement: p.isValidElement
};
function y(t, n) {
  n === void 0 && (n = {});
  for (var o = [], E = typeof n.replace == "function", m = n.transform || s.returnFirstArg, c = n.library || M, b = c.cloneElement, v = c.createElement, g = c.isValidElement, d = t.length, r = 0; r < d; r++) {
    var e = t[r];
    if (E) {
      var l = n.replace(e, r);
      if (g(l)) {
        d > 1 && (l = b(l, {
          key: l.key || r
        })), o.push(m(l, e, r));
        continue;
      }
    }
    if (e.type === "text") {
      var u = !e.data.trim().length;
      if (u && e.parent && !(0, s.canTextBeChildOfNode)(e.parent) || n.trim && u)
        continue;
      o.push(m(e.data, e, r));
      continue;
    }
    var a = e, i = {};
    V(a) ? ((0, s.setStyleProp)(a.attribs.style, a.attribs), i = a.attribs) : a.attribs && (i = (0, C.default)(a.attribs, a.name));
    var f = void 0;
    switch (e.type) {
      case "script":
      case "style":
        e.children[0] && (i.dangerouslySetInnerHTML = {
          __html: e.children[0].data
        });
        break;
      case "tag":
        e.name === "textarea" && e.children[0] ? i.defaultValue = e.children[0].data : e.children && e.children.length && (f = y(e.children, n));
        break;
      default:
        continue;
    }
    d > 1 && (i.key = r), o.push(m(v(e.name, i, f), e, r));
  }
  return o.length === 1 ? o[0] : o;
}
function V(t) {
  return s.PRESERVE_CUSTOM_ATTRIBUTES && t.type === "tag" && (0, s.isCustomComponent)(t.name, t.attribs);
}
